import { render, staticRenderFns } from "./LinkCell.vue?vue&type=template&id=60ee2f87&scoped=true&"
import script from "./LinkCell.vue?vue&type=script&lang=js&"
export * from "./LinkCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ee2f87",
  null
  
)

export default component.exports